export const REPOSITORY_VERSION = "1a02b3a"
